module.exports = __webpack_public_path__ + "static/img/__8679.676480f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8679.jpg
// module id = 10nY
// module chunks = 0